import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppBar, Badge, Icon, IconButton, Toolbar } from '@mui/material'
import { withStyles } from '@mui/styles'
import { style } from 'styles'

function TopBar({ classes, toggleMenuOpen }) {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const { product } = useSelector(state => state.products)
	const { products } = useSelector(state => state.cart)
	const path = window.location.pathname.split('/').filter(v => v != '')
	//const showBackButton = path[0] == 'shop' || path[0] == 'offers' || path[0] == 'reservations' // && path[1] == 'prod'
	const showBackButton = path[1] != undefined || path[0] == 'offers'
	const shop = useSelector(state => state.shop)
	const isCatalogue = Number(shop.profiles.ueby_catalogue_only)
	const isOrder = window.location.pathname.split('/').filter(v => v != '')[0] == 'order' && window.location.pathname.split('/').filter(v => v != '')[0] == 'create'

	const goBack = () => {
		if (window.history.state && window.history.state.idx > 0) {
			// Vado alla pagina precedente di navigazione
			navigate(-1)
		} else {
			// Vado all'elenco prodotti
			switch (shop.profiles.ueby_categories_display_mode) {
				case '1':
					navigate(`/shop/${product.category.ecom_url}`)
					break

				case '2':
				case '3':
					navigate('/shop')
					break
			}
		}
	}

	const getCartQuantity = () => {
		const quantity = products.map(product => product.quantity).reduce((a, b) => Number(a) + Number(b), 0)
		return quantity
	}

	return (<AppBar position="fixed" className={classes.topBar}>
		<Toolbar>
			{isOrder && <React.Fragment>
				<IconButton edge="start" color="inherit" aria-label="menu" onClick={() => navigate('/')}>
					<Icon>cancel</Icon>
				</IconButton>
				Completa l'ordine
			</React.Fragment>}

			{!isOrder && <React.Fragment>
				{showBackButton && <IconButton edge="start" color="inherit" aria-label="menu" onClick={goBack}>
					<Icon>chevron_left</Icon>
				</IconButton>}
				<IconButton edge="start" color="inherit" aria-label="menu" onClick={() => toggleMenuOpen(true)}>
					<Icon>menu</Icon>
				</IconButton>
				<div className="logoContainer">
					<img src="/logo512.png" alt="" className="logo" />
				</div>

				{!isCatalogue &&
					<IconButton edge="end" color="inherit" aria-label="carrello" onClick={() => dispatch({ type: 'toggle@cart', openState: true })}>
						<Badge badgeContent={getCartQuantity()} color="secondary">
							<Icon>shopping_cart</Icon>
						</Badge>
					</IconButton>
				}
			</React.Fragment>}
		</Toolbar>
	</AppBar>)
}

export default withStyles(style)(TopBar)
